import * as React from "react";
import PropTypes from "prop-types";
import Logos from "./Logos";
import HeroVideo from "./HeroVideo";
import css from "./Hero.module.css";

export default function Hero({ isMobile }) {
  return (
    <div className={css.heroWrapper}>
      <div className={css.box}>
        <div className={css.left}>
          <h1 className={css.title}>
            <span className={css.titleA}>Autographs </span>
            <span className={css.titleB}>Livestreamed</span>
          </h1>

          <p className={css.subtitle}>
            Watch your favorite talent sign personalized autographs for you on
            camera. Delivered right to your door!
          </p>

          {!isMobile && <Logos />}
        </div>

        {!isMobile && <HeroVideo />}
      </div>

      <svg
        className={css.wave}
        viewBox="0 0 1440 48"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path d="M0 0c240 48 480 48 720 24S1200 0 1440 24V0H0z" fill="white" />
      </svg>
    </div>
  );
}

Hero.propTypes = {
  isMobile: PropTypes.bool,
};
